import React from 'react';
import Hero from './components/facilities/Hero';
import Main from './components/facilities/Main';
import ImportantLinksSlider from './components/Home/ImportantLinksSlider';

const Facilities = () => {
  return (
    <div>
        <Hero />
        <Main />
        <ImportantLinksSlider />
    </div>
  )
}

export default Facilities;